import React from 'react'
import ContentSection from '../ContentSection'
import { ReactComponent as DefaultIllustration } from '../../../assets/images/habitacional/illustration-document-gael.svg'
import DownloadDocument from '../core/DownloadDocument/DownloadDocument'

const GeneralCondition = ({ illustration, documentList, description }) => {

    return (
        <ContentSection 
            title="Condições Gerais"
            description={description}
            illustration={illustration || <DefaultIllustration />}
            reverse
        >
            <DownloadDocument 
                documents={documentList}/>
        </ContentSection>
    )
}

export default GeneralCondition